import React, { useState } from 'react';
import { Map as VisMap, AdvancedMarker } from '@vis.gl/react-google-maps';
import { visMapOptions } from './visMapOptions';
import MapPositionInteractive from './MapPositionInteractive';
import ReportForm from '../../../components/ReportForm';
import { useSearchParams } from 'react-router-dom';

export default function Map(props: { className: string; urlReportEnabled?: boolean }) {
    const [, setUrlParams] = useSearchParams();
    const [selectedCoordinates, setSelectedCoordinates] = useState<undefined | { lat: number; lng: number }>(undefined);
    const [showReportModal, setShowReportModal] = useState<boolean | undefined>(undefined);

    const [center, setCenter] = useState<{ lat: number; lng: number } | undefined>({ lat: 52, lng: 19 });
    const [zoom, setZoom] = useState<number>(8);

    return (
        <>
            {selectedCoordinates && showReportModal !== undefined && (
                <ReportForm
                    show={showReportModal}
                    onClose={() => {
                        setShowReportModal(false);
                        setUrlParams({});
                    }}
                    coordinates={
                        (window as any).google?.maps?.LatLng
                            ? (new (window as any).google.maps.LatLng(
                                  selectedCoordinates.lat,
                                  selectedCoordinates.lng,
                              ) as google.maps.LatLng)
                            : ({
                                  toJSON: () => ({ lat: selectedCoordinates.lat, lng: selectedCoordinates.lng }),
                                  toUrlValue: () => `${selectedCoordinates.lat},${selectedCoordinates.lng}`,
                                  equals: () => false,
                              } as unknown as google.maps.LatLng)
                    }
                />
            )}
            <MapPositionInteractive
                onReport={() => setShowReportModal(true)}
                onCenterChange={(pos) => setCenter(pos)}
                onSetZoom={(z) => setZoom(z)}
                selectedCoordinates={selectedCoordinates}
            />

            <VisMap
                defaultCenter={center}
                defaultZoom={zoom}
                mapId={"MAIN_MAP"}
                className={props.className}
                zoomControl={visMapOptions.zoomControl}
                mapTypeControl={visMapOptions.mapTypeControl}
                streetViewControl={visMapOptions.streetViewControl}
                fullscreenControl={visMapOptions.fullscreenControl}
                zoomControlOptions={visMapOptions.zoomControlOptions}
                mapTypeControlOptions={visMapOptions.mapTypeControlOptions}
                streetViewControlOptions={visMapOptions.streetViewControlOptions}
                fullscreenControlOptions={visMapOptions.fullscreenControlOptions}
                onClick={(e: any) => {
                    const latLng = e?.detail.latLng
                    const position = latLng && typeof latLng.toJSON === 'function' ? latLng.toJSON() : latLng;
                    console.log(e);
                    if (position) {
                        setSelectedCoordinates(position);
                        setCenter(position);
                    }
                }}>
                {selectedCoordinates && <AdvancedMarker position={selectedCoordinates as any} />}
            </VisMap>
        </>
    );
}
